import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { GoogleButton } from "@/pages/AuthPages";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.name}`);
      nav(u.role === "admin" || u.role === "staff" || u.role === "super_admin" ? "/admin" : "/dashboard");
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : "Login failed");
    } finally { setLoading(false); }
  };
  return (
    <section className="max-w-[520px] mx-auto px-6 py-24">
      <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">Sign In</p>
      <h1 className="font-serif text-5xl mt-2">Welcome back.</h1>
      <div className="mt-10"><GoogleButton /></div>
      <div className="my-8 flex items-center gap-4 text-xs font-mono tracking-[0.3em] uppercase text-[#888]">
        <div className="flex-1 h-px bg-[#E5E5E5]" /> or <div className="flex-1 h-px bg-[#E5E5E5]" />
      </div>
      <form onSubmit={submit} className="space-y-6">
        <div>
          <label className="text-xs font-mono tracking-[0.3em] uppercase">Email</label>
          <input data-testid="login-email" type="email" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2 w-full border-b border-[#E5E5E5] focus:border-[#C5A059] outline-none py-3 bg-transparent" />
        </div>
        <div>
          <label className="text-xs font-mono tracking-[0.3em] uppercase">Password</label>
          <input data-testid="login-password" type="password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-2 w-full border-b border-[#E5E5E5] focus:border-[#C5A059] outline-none py-3 bg-transparent" />
        </div>
        {err && <p className="text-sm text-[#9A1F1F]" data-testid="login-error">{err}</p>}
        <button data-testid="login-submit" disabled={loading} className="w-full bg-[#0a0a0a] text-white hover:bg-[#C5A059] hover:text-[#0a0a0a] transition-colors px-8 py-4 text-xs tracking-[0.25em] uppercase font-bold">{loading ? "Signing in..." : "Sign In"}</button>
      </form>
      <div className="mt-8 flex flex-wrap justify-between gap-2 text-sm">
        <Link to="/forgot-password" className="text-[#555] hover:text-[#C5A059]" data-testid="link-forgot">Forgot password?</Link>
        <Link to="/register" className="text-[#555] hover:text-[#C5A059]" data-testid="link-register">Create account</Link>
      </div>
    </section>
  );
}

